<template>
  <div>
    <div class="pr-4 pb-4">
      <v-text-field light label="Title" v-model="item.name" type="text" required color="amber"
        placeholder="Name"></v-text-field>
      <v-textarea light label="Description" v-model="item.sentence" type="text" required color="amber" :rows="2"
        placeholder="Description" class="" :autoGrow="true" :hide-details="true"></v-textarea>
      <v-checkbox light v-model="item.highlight" label="Highlight"></v-checkbox>

      <div class="sliders">


        <div>
          <p class="text-h6 mb-0">Effort</p>
          <small>How easy is it to update the asset (cost, legal, systems, supply chain)?</small>
          <v-slider v-model="item.scores.slider1" label="" step="1" min="0" max="5" ticks="always" tick-size="4"
            color="amber text--black" track-color="grey lighten-2" light></v-slider>
        </div>
        <div>
          <p class="text-h6 mb-0">Impact</p>
          <small>Will rebranding this asset build equity in the new company? Will endorsing this asset retain equity
            of legacy company?</small>
          <v-slider v-model="item.scores.slider2" label="" step="1" min="0" max="5" ticks="always" tick-size="4"
            color="amber text--black" track-color="grey lighten-2" light></v-slider>
        </div>
        <div>
          <p class="text-h6 mb-0 black--text">Regulatory & safety considerations</p>
          <small>Is this a mandatory requirement?</small>
          <!-- <small>Does changing this asset require approvals, compliance review, technical updates?</small> -->
          <v-checkbox light v-model="item.scores.regulation" label="Mandatory"></v-checkbox>
        </div>
        <div class="mt-2 mb-4 score-circle"
          :style="{ borderColor: getBorderColor(calculateRolloutPriorityScore(item.scores).score) }">
          {{
            calculateRolloutPriorityScore(item.scores).score }}</div>

      </div>

      <!-- <v-select :items="local.categories" label="Category" multiple v-model.trim="item.categories" light></v-select> -->
      <!-- <v-select :items="local.priorities" label="Priority" v-model.trim="item.priorities" light></v-select> -->
      <!-- <v-select :items="local.brand" label="Brand" v-model.trim="item.brand" light></v-select> -->

      <PhaseForm :local="local" v-model="item.phases" title="Phased roll-out" />

      <unit-sub-items v-if="attrs.touchpoints" v-model="item.items" name="sub" class="mb-6">
        <v-label><span class="black--text">Touchpoints</span></v-label>
        <p class="ma-0">Add additional items</p>
      </unit-sub-items>

      <v-textarea light label="Notes" v-model="item.body" type="text" color="amber" :rows="2" placeholder="..."
        class="my-10" :autoGrow="true" :hide-details="true"></v-textarea>

    </div>

    <div class="d-flex justify-end align-center pr-3">
      <v-btn @click="submit" color="amber" class="mr-2" light>Update</v-btn>
      <v-btn @click="cancel" color="grey" class="" light>Cancel</v-btn>
    </div>
  </div>
</template>

<script>
import { itemModel, calculateRolloutPriorityScore, getBorderColor } from './model'
import { UnitSubItems } from '@/components/units'
import PhaseForm from '@/views/user/exercises/roll-out/PhaseForm'

export default {
  name: 'RollOutForm',
  components: { UnitSubItems, PhaseForm },
  props: {
    newItem: {
      type: Object,
      default: () => { }
    },
    colors: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    },
    local: {
      type: Object,
      default: () => { }
    },
    attrs: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      item: this.createItem(this.newItem),
      panel: [0, 1],
      calculateRolloutPriorityScore,
      getBorderColor,
      itemModel
    }
  },
  methods: {
    createItem(item) {
      const proto = {}
      Object.keys(itemModel).forEach(key => {
        proto[key] = item[key] ? item[key] : itemModel[key]
      })
      return proto
    },
    submit() {
      console.log('submit', this.item)
      this.$emit('submit', this.item)
    },
    cancel() {
      this.$emit('cancel', this.item)
    }
  }
}
</script>

<style lang="scss" scoped>
.score-circle {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  // background: white;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
}
</style>